<template>
  <div class="product">
    <div class="desc">
      <h1 class="prod_title" v-html="product.Titel"></h1>
      <h2 class="prod_subtitle" v-html="product.Untertitel"></h2>
      <div class="prod_desc" v-html="product.Beschreibung"></div>
    </div>
    <div class="prodpicture_cont">
      <ul class="piclist">
        <li v-for="img of product.pics" class="img">
          <ProductPicture :alt="img.alt" :src="img.src"></ProductPicture>
        </li>
      </ul>
    </div>
    <div class="order_info">
      <h3>Bestelldaten</h3>
      <table id="order_info" v-html="product.Bestellinformation" v-bind:class="isHacky"></table>
    </div>
  </div>
</template>
<script>
  import ProductPicture from '@/components/picture_el'
  export default {
    name: 'Product',
    props: ['id'],
    data () {
      return {
        product: this.product
      }
    },
    components: { ProductPicture },
    mounted () {
      console.log('mounted')
      this.fetchThings()
    },
    computed: {
      pics: function () {},
      isHacky: function () {
        return {
          hacky: (this.id == "29")
        }
      }
    },
    /*updated () {
      this.$nextTick(function () {
        let td = document.querySelectorAll('.prod_desc > div > table')
        for (let t in td) {
          console.log(t)
          t.classList.add('techtable')
        }
      })
    },*/
    watch: {
      language: function () {
        this.fetchThings()
      }
    },
    methods: {
      fetchPictures: function () {
        let bilder = JSON.parse(this.product.Bilder)
        //console.log(bilder)
        return bilder
      },
      fetchThings: function () {
        let url = 'https://backend.schuett-biotec.de/'+this.language+'/product/' + this.id
        //console.log(url)
        fetch(url)
        .then((response) => {
          return response.json()
        })
        .then((product) => {
          let prod = product
          prod.Beschreibung = product.Beschreibung.replace(/\t*/g, '')
          prod.Bestellinformation = product.Bestellinformation.replace(/\t*/g, '')
          this.product = product
          this.product.pics = this.fetchPictures()
        })
        .catch((err) => {
          console.log(err)
        })
      }
    }
  };
</script>
<style scoped>
  h1,h2 {
    color: black;
  }

  .product {
    display: -ms-grid;
    display: grid;
    grip-gap: 10px;
    -ms-grid-rows: auto auto;
    -ms-grid-columns: 60% auto;
        grid-template:
      "desc pic"
      "order pic" /
      60% auto;
    padding: 20px;
    color: black;
  }

  .product > div {
    -webkit-box-flex: 1;
        -ms-flex: 1 0 auto;
            flex: 1 0 auto;
  }
  ul {
    list-style: none;
  }
  .prod_title, .prod_subtitle {
    text-align: left;
    padding-left: 10px;
  }

  .prod_desc {
    padding: 10px;
    display: block;
  }
  .desc {
    -ms-grid-row: 1;
    -ms-grid-column: 1;
    grid-area: desc;
  }
  .desc > table {
    border: none;
  }
  .desc > table > tbody > tr > td {
    border: none;
  }

  .prodpicture_cont {
    -ms-grid-row: 1;
    -ms-grid-row-span: 2;
    -ms-grid-column: 2;
    max-width: 40vw;
    grid-area: pic;
  }

  .order_info {
    -ms-grid-row: 2;
    -ms-grid-column: 1;
    grid-area: order;
  }

  @media only screen and (max-width: 810px) and (orientation: portrait){
    .product {
      display: -ms-grid;
      display: grid;
      grip-gap: 10px;
      -ms-grid-rows: auto auto auto;
      -ms-grid-columns: auto;
          grid-template:
        "desc"
        "pic"
        "order" /
        auto;
      padding: 20px;
      color: black;
    }

    .prodpicture_cont {
      -ms-grid-row: 2;
      -ms-grid-column: 1;
      max-width: inherit;
    }

    .order_info {
      -ms-grid-row: 3;
    }
  }

  .order_info > table {
    border: 1px solid;
  }
  .order_info > table > tbody > tr > td {
    border: 1px solid;
    text-align: left;
  }
  .img > span {
    font-size: .8em;
  }
  .img > img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Product.vue